import _ from 'lodash'

/**
 * 
 * @param {string} url 
 * @returns 
 */
export function getUrlExtension( url ) {
    return url.split(/[#?]/)[0].split('.').pop().trim();
}

/**
 * 
 * @param {string} str 
 * @returns 
 */
export function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

/**
 * 
 * @param {*} step 
 * @returns string
 */
export function getStepRenderType(step) {
    //console.log(step)
    let _type = null
    if ('stepTypeId' in step && step.stepTypeId !== null ) {
        _type = step.stepTypeId
    } else {
        if ( isJson(step.content) ) {
            _type = 'json'
        } else {
            
            _type = getUrlExtension(step.content)
            console.log(_type)
        }
    }
    return _type;
}